<template>
  <div class="card card-borderless">
    <ul
      class="nav nav-tabs"
      :class="tab_class"
      role="tablist"
      data-init-reponsive-tabs="dropdownfx"
    >
      <li
        class="nav-item"
        v-for="(tab, index) in dataTabs"
        :key="index"
        @click="switchTab(tab)"
      >
        <a
          :class="['tab-button', { active: currentTab.name === tab.name }]"
          data-toggle="tab"
          role="tab"
          :data-target="'#tabs-' + index"
          href="#"
          @click="currentTab = tab"
        >
          <i :class="tab.icon_class" /> {{ tab.name }}
          <span
            v-if="tab.is_badge"
            style="
              background: red;
              height: 10px;
              width: 10px;
              border-radius: 100%;
            "
            class="m-l-5 pull-right"
          />
        </a>
      </li>
    </ul>
    <div class="tab-content">
      <div>
        <component
          :is="currentTab.component"
          :key="tab_key"
          :data="currentTab.data ? currentTab.data : []"
          class="tab"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  props: {
    tabs: {
      type: Array,
    },
    actived: {
      type: Number,
      default: 0,
    },
    tab_class: {
      type: String,
      default: "nav-tabs-simple",
    },
  },
  data() {
    return {
      dataTabs: this.tabs,
      currentTab: this.tabs[this.actived],
      tab_key: 0,
    };
  },
  methods: {
    switchTab: function (tab) {
      this.currentTab = tab;
      if (this.currentTab.data && !("no_refresh" in this.currentTab)) {
        this.tab_key++;
      }
    },
  },
};
</script>

<style scoped>
.nav-tabs-simple > li > a:after {
  background-color: #0f8ff9 !important;
}
.nav-tabs-fillup > li > a:after {
  background-color: #00a46c !important;
}
</style>